import React, { FC, Fragment, ReactChild } from 'react';
import { useTranslation } from 'react-i18next';

import { Content } from 'api';
import { getFullName } from 'helpers';

interface IProps {
  isLiked: boolean;
  reactions: Content['reactions'];
}

const Text: FC<IProps> = ({ reactions, isLiked }) => {
  const { t } = useTranslation();
  const safeReactions = reactions || {
    reaction_count: { total: 0 },
    reaction_user_details: [],
  };

  const {
    reaction_count: { total },
    reaction_user_details: [user],
  } = safeReactions;

  const currentPlusOne: boolean = total === 2 && isLiked;
  const twoOrMore: boolean = total >= 2;
  const name = getFullName(user);

  const textElement = (children: ReactChild) => <span>{children}</span>;
  let childElement;

  if (!total) {
    return textElement(null);
  }

  if (total === 1) {
    const currentUser = t('content:reactionsOneCurrentUser');
    const otherUser = t('content:reactionsOneDifferentUser', { name });
    const text = isLiked ? currentUser : otherUser;

    return textElement(<Fragment>{text}</Fragment>);
  }

  if (currentPlusOne) {
    const text = t('content:reactionsCurrentPlusOne', { name });
    return textElement(<Fragment>{text}</Fragment>);
  }

  if (twoOrMore) {
    const adjustedTotal = isLiked ? total - 2 : total - 1;
    const options = { name, count: adjustedTotal };
    const key = isLiked ? 'content:reactionsTwoPlusCurrent' : 'content:reactionsTwoPlus';

    childElement = textElement(<Fragment>{t(key, options)}</Fragment>);
  }

  return childElement;
};

export default Text;
